module.exports = __webpack_public_path__ + "img/image10.00a11083.png";